<template>
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-6 p-4 flex flex-col">
            <p class="mb-5 text-base font-medium text-gray-500">
            	Clear Login Cards Cache            
            </p>
            <p>
	            <a href="#" @click.prevent="clearLoginCardsCache" role="button" class="btn btn-primary"
	                >Clear Login Cards Cache</a
	            >
			</p>
        </div>
        <div class="col-span-6 p-4 flex flex-col">
            <p class="mb-5 text-base font-medium text-gray-500">
            	Clear Wallet Tags Cache
            </p>
            <p>
				<a href="#" @click.prevent="clearWalletsTagsCache" role="button" class="btn btn-primary"
	                >Clear Wallets Tags Cache</a
	            >            
			</p>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        clearLoginCardsCache() {
            ApiService.apiCall('/admin/settings/clear-login-cards-cache', 'post')
                .then((response) => {
                    this.$notify(
                        {
                            group: 'success',
                            title: 'Success',
                            text: 'Login cards cache cleared',
                        },
                        4000
                    );
                })
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                });
        },
        clearWalletsTagsCache() {
            ApiService.apiCall('/admin/settings/clear-wallets-tag-cache', 'post')
                .then((response) => {
                    this.$notify(
                        {
                            group: 'success',
                            title: 'Success',
                            text: 'Wallets tags cache cleared',
                        },
                        4000
                    );
                })
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                });
        },
    },
};
</script>
